/**
 * Component added to entities to hold a reference to a product Id
 * whose details will be displayed when clicking the context menu Info button
 */
class InfoActionTargetComponent {
    constructor(targetProductId) {
        this.targetProductId = targetProductId;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.typeId = InfoActionTargetComponent.id;
    }
    eq() {
        return true;
    }
}
InfoActionTargetComponent.id = 2101;
export default InfoActionTargetComponent;
//# sourceMappingURL=InfoActionTargetComponent.js.map